import React from 'react';

import Svg from './comment.svg';

const Comment = (props) => {
  return <Svg {...props} viewBox="0 0 24 24" />;
};

export default Comment;
